import { render, staticRenderFns } from "./OptionCardForModal.vue?vue&type=template&id=d0b2973e&scoped=true"
import script from "./OptionCardForModal.vue?vue&type=script&lang=js"
export * from "./OptionCardForModal.vue?vue&type=script&lang=js"
import style0 from "./OptionCardForModal.vue?vue&type=style&index=0&id=d0b2973e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b2973e",
  null
  
)

export default component.exports